module.exports = __webpack_public_path__ + "img/event-banner01-m.36cfe470.png";